import React from 'react';
import ReactDOM from 'react-dom/client';
import PortfolioApp from './PortfolioApp';
import './sass/styles.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <PortfolioApp />
);